import { historicoParceiroStyles } from './HistoricoParceiro.style'

export function historicoParceiroIO() {
  return {
    styles: historicoParceiroStyles
  }
}

export type HistoricoParceiroIO = ReturnType<typeof historicoParceiroIO>
